import React from "react";
import styled, { css } from "styled-components";
import { theme } from "../../theme/theme";
import { useLocale } from "../../hooks/useLocale";

const formStyles = css`
  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  label {
    padding-bottom: 8px;
    display: inline-block;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    span {
      margin-left: 8px;
    }
  }
  .hs-fieldtype-booleancheckbox {
    input {
      width: auto;
    }
    ul {
      margin-block-end: 0px !important;
    }
    label {
      padding: 0px !important;
    }
  }
  .hs-form-required {
    color: #d45f47;
    margin-left: 3px;
  }
  .input.hs-input.error {
    color: #d45f47;
  }
  .hs-error-msg,
  .hs-error-msgs li {
    font-size: 14px;
    color: ${theme.accent};
  }
  .submitted-message {
    color: #fff;
    text-align: ${({ layout }) => (layout === "purple" ? "center" : "left")};
  }
  .hs-input {
    width: 100%;
    border: none;
    border-radius: 20px;
    background-color: #e9e7ef;
    padding: 16px 32px;
    ${(p) => (p.invalid ? `background-color:  ${theme.accent};` : "")}
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  .hs-submit .hs-button {
    border: none;
    border-radius: 56px;
    text-transform: uppercase;
    background-color: white;
    color: ${theme.primary};
    font-size: 16px;
    font-weight: 600;
    font-family: "Source sans 3", sans-serif;
    height: 50px;
    padding: 0px 28px;
    width: 50%;
    cursor: pointer;
    border: 2px solid rgb(63, 40, 96);
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  .hs-form-booleancheckbox-display {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }
  .hs-input[type="checkbox"] {
    appearance: none;
    background-color: #e9e7ef;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    :checked {
      appearance: auto;
      accent-color: ${theme.primary};
    }
    padding: 0px;
  }
`;

export const useHubspotForm = (
  formId,
  onFormSubmitted,
  dependency,
  defaultValues
) => {
  const locale = useLocale();
  const [submitted, setSubmitted] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  let targetBase = "hubspotForm";
  const target = targetBase + "-" + formId;

  React.useEffect(() => {
    setLoading(true);
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "19625954",
          formId: formId,
          target: "#" + target,
          locale: locale,
          translations: {
            fi: {
              required: "Täytä pakollinen kenttä"
            },
            en: {
              required: "Please fill out this field"
            }
          },
          onFormSubmitted: () => {
            setSubmitted(true);
            onFormSubmitted?.();
          },
          onFormReady: (form) => {
            if (defaultValues) {
              Object.entries(defaultValues).map(([key, value]) => {
                const element = form.querySelector(`input[name="${key}"]`);
                element.defaultValue = value;
                element.dispatchEvent(new Event("change", { bubbles: true }));
              });
            }

            setLoading(false);
          }
        });
      }
    });
  }, dependency || []);
  return {
    submitted,
    loading,
    hsForm: <div id={target} />
  };
};
